import SideMenu from "./SideMenu";
// import Sidebar from "../../components/dashboard/sidebar";

import Footer from "../../components/footer/Footer";
import Header from "../Header";
const LectureModule = () => {

    return (

        <main>
            <Header />

            <div className="wrapper client_wrapper">

              <SideMenu />

                <div className="content_blockk">

                    Coming Soon....</div>
            </div>

            <Footer />
        </main>
    )
}

export default LectureModule